import { render, staticRenderFns } from "./addBaseAdData.vue?vue&type=template&id=e510a6ce&scoped=true"
import script from "./addBaseAdData.vue?vue&type=script&lang=js"
export * from "./addBaseAdData.vue?vue&type=script&lang=js"
import style0 from "./addBaseAdData.vue?vue&type=style&index=0&id=e510a6ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e510a6ce",
  null
  
)

export default component.exports